import styled from 'styled-components';

const TimeSeriesKeyChipColor = styled.div`
    background-color: ${({ $color }) => $color};
    min-width: 0.25rem;
    min-height: 1.5rem;
    border-radius: 0 0.2rem 0.2rem 0;
    margin-right: 0.5rem;
`;

export default TimeSeriesKeyChipColor;
